(ns frontend.view.reports.custom.diamond-edge-ventures-charts
  (:require
   [clojure.string :as string]
   [common.localization :as loc]
   [frontend.db :as app-db]
   [frontend.exports.excel :as excel]
   [frontend.ui.component.chart.view :as chart-view]
   [frontend.view.components.clipboard :as clipboard]
   [frontend.view.reports.custom.diamond-edge-common :as diamond-edge-common]
   [frontend.view.reports.custom.diamond-edge-ventures.report-1-total-engagement :as report-1-data]
   [frontend.view.reports.custom.diamond-edge-ventures.report-2-total-engagement :as report-2-data]
   [reagent.core :as r]
   [ui.components.card.view :as card]))


(defn ^{:jsdoc ["@nocollapse"]} format-data-point
  [_]
  (this-as js-data-point
    (let [data-point (js->clj js-data-point :keywordize-keys true)
          {:keys [y x]} data-point]
      (str (->> (string/split (:key data-point) " ")
                (string/join "<br>"))

           " : "
           y))))

(defn pie-1
  [{:keys [view-name total-deals chart-data report-data x-axis-labels]}]
  [card/card
   [card/header
    [:span.title-h3.d-inline-block.pr-2
     view-name
     " "
     [:span.grid-count
      (str (loc/tr :total-deals) ": " total-deals)]]
    [:div.d-flex.justify-content-end
     [:i.fal.fa-copy.mr-3.pointer
      {:title    (loc/tr :copy-to-clipboard)
       :on-click (fn [_]
                   (clipboard/copy-as-tsv report-data))}]
     [:i.fal.fa-file-excel.pointer
      {:title    (loc/tr :save-as-excel)
       :on-click (fn [_]
                   (excel/export-array-data view-name
                                            report-data))}]]]
   [card/body
    [:div.reports-chart-wrapper
     (let [raw-config {:chart       {:type            "pie"
                                     :backgroundColor "#FFFFFF"
                                     :borderRadius    10
                                     :width           (let [window-width (:width @app-db/window)]
                                                        (cond (< window-width 900)
                                                              (- window-width 210)

                                                              :else
                                                              (min (int (/ (- window-width 210) 2))
                                                                   1000)
                                                              ))}
                       :title       nil
                       :xAxis       {:categories x-axis-labels}
                       :yAxis       {:min             0
                                     :stackLabels     {:enabled true}
                                     :lineWidth       0
                                     :minorTickLength 0
                                     :tickLength      0
                                     :tickInterval    10
                                     :gridLineColor   "#F2F2EE"
                                     :title           {:enabled false}
                                     :plotLines       [{:value  0
                                                        :width  2
                                                        :color  "#000"
                                                        :zIndex 10}]}
                       :series      [{:data chart-data}]
                       :credits     {:enabled false}
                       :legend      {:enabled false}
                       :borderWidth 1
                       :shadow      false
                       :tooltip     {:headerFormat "<b>{point.x}</b><br/>"
                                     :pointFormat  "{point.name}: {point.y}"}
                       :plotOptions {:pie {:dataLabels {:enabled        true
                                                        :pointFormatter format-data-point
                                                        :useHTML        true
                                                        :distance       20}}}}]
       [chart-view/chart raw-config])]]])

(defn report-1
  []
  (let [reports-state (r/atom (diamond-edge-common/get-filter-default-values))]
    (fn []
      (let [data (report-1-data/oppos-by-status-or-deal-type reports-state)
            [_ total-count] (last data)]
        [:div
         [diamond-edge-common/filters reports-state]
         [:div.row
          [:div
           [pie-1
            {:view-name   "Total Engagement - UTD"
             :total-deals total-count
             :chart-data  (butlast data)
             :report-data data
             }]]]]))))


(defn graph-2
  [{:keys [view-name total-deals series-data report-data x-axis-labels] :as props}]
  [card/card
   [card/header
    [:span.title-h3.d-inline-block.pr-2
     view-name
     " "
     [:span.grid-count
      (str (loc/tr :total-deals) ": " total-deals)]]
    [:div.d-flex.justify-content-end
     [:i.fal.fa-copy.mr-3.pointer
      {:title    (loc/tr :copy-to-clipboard)
       :on-click (fn [_]
                   (clipboard/copy-as-tsv report-data))}]
     [:i.fal.fa-file-excel.pointer
      {:title    (loc/tr :save-as-excel)
       :on-click (fn [_]
                   (excel/export-array-data view-name
                                            report-data))}]]]
   [card/body
    [:div.reports-chart-wrapper
     (let [raw-config {:chart       {:type            "column"
                                     :backgroundColor "#FFFFFF"
                                     :borderRadius    10
                                     :width           (let [window-width (:width @app-db/window)]
                                                        (cond (< window-width 900)
                                                              (- window-width 210)

                                                              :else
                                                              (min (int (/ (- window-width 210) 2))
                                                                   1000)
                                                              ))}
                       :title       nil
                       :xAxis       {:categories x-axis-labels}
                       :yAxis       {:min             0
                                     :stackLabels     {:enabled true}
                                     :lineWidth       0
                                     :minorTickLength 0
                                     :tickLength      0
                                     :tickInterval    10
                                     :gridLineColor   "#F2F2EE"
                                     :title           {:enabled false}
                                     :plotLines       [{:value  0
                                                        :width  2
                                                        :color  "#000"
                                                        :zIndex 10}]}
                       :series      series-data
                       :credits     {:enabled false}
                       :legend      {:enabled false}
                       :borderWidth 1
                       :shadow      false
                       :tooltip     {:headerFormat "<b>{point.x}</b><br/>"
                                     :pointFormat  "{point.name}: {point.y}"}
                       :plotOptions {:column {:stacking   "normal"
                                              :dataLabels {:enabled true}}}}]
       [chart-view/chart raw-config])]]])

(defn report-2
  []
  (let [reports-state (r/atom (diamond-edge-common/get-filter-default-values))]
    (fn []
      (let [data (report-2-data/oppos-by-status-or-deal-type reports-state)]
        [:div
         [diamond-edge-common/filters reports-state]
         [:div.row
          [:div
           [graph-2
            (or
             #_{:view-name     "Total Engagement - by stage"
                :x-axis-labels ["Stop" "Hold" "Active" "Portfolio" "Transfer to BU" "Stage-up"]
                :total-deals   38
                :series-data   [{:name "NDA/MTA" :data [0 0 9 0 0 11]} {:name "Evaluation" :data [5 0 4 0 4 2]}
                                {:name "Partnership" :data [0 0 1 0 0 1]} {:name "Business" :data [0 0 1 0 0 0]}]
                :report-data   [["NDA/MTA" 0 0 9 0 0 11 20] ["Evaluation" 5 0 4 0 4 2 15] ["Partnership" 0 0 1 0 0 1 2]
                                ["Business" 0 0 1 0 0 0 1] ["Total" 5 0 15 0 4 14 38]]}
             {:view-name     "Total Engagement - by stage"
              :x-axis-labels ["Stop" "Hold" "Active" "Portfolio" "Transfer to BU" "Stage-up"]
              :total-deals   (->> data
                                  (last)
                                  (last))
              :series-data   (->> data
                                  (butlast)
                                  (map (fn [row]
                                         {:name (first row)
                                          :data (->> row
                                                     (rest)
                                                     (butlast)
                                                     (vec))}))
                                  (vec))
              :report-data   data})]]]]))))
(defn view
  []
  (fn []
    [:div
     [report-1]
     [report-2]]))
